module.exports = __webpack_public_path__ + "img/catalog.0130ecea.svg";